import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { QuizCompleteContainer, ResultsContainer } from './QuizComplete.styles';
import DisplayUser from '../DisplayUserInfo/DisplayUserComponent.component';
import ReviewQuiz from '../ReviewQuiz/ReviewQuiz.component';
import FinishedPicture from '../../../Visuals/Images/finished.svg';
import { AuthCheckUser } from '../../../Utils/AuthCheck/UserCheck.auth';
import Auth from '../../../Helpers/auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component.jsx';
import Part2Checker from '../../../Components/Part2.component.jsx';
import CourseDataProvider from '../../../Utils/Courses/CourseDataProvider.jsx';
import UserDataProvider from '../../../Utils/Users/UserDataProvider.jsx';
import IncompleteButtons from '../ComIncButtons/IncompleteButtons.component.jsx';
import CompleteButton from '../ComIncButtons/CompleteButtons.component.jsx';

const CourseComplete = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = Auth.getProfile();
  const userId = data?.id || localStorage.getItem('temp_id');
  const courseId = localStorage.getItem('courseId');

  return (
    <AuthCheckUser>
      <HelmetHelper
        title="Course Complete"
        description="Course has been completed, review the quiz and download certificate"
      />
      <CourseDataProvider courseId={id}>
        {(course) => (
          <UserDataProvider userId={userId} courseId={courseId}>
            {(userInfo) => (
              <>
                <QuizCompleteContainer>
                  <ResultsContainer>
                    <img src={FinishedPicture} alt="Course Complete" />
                    <DisplayUser
                      courseName={course?.courseName}
                      score={userInfo?.courses?.[0]?.score}
                    />
                  </ResultsContainer>
                  {/* TDG Certificate Button */}
                  {course?.courseName?.includes('TDG') && (
                    <IncompleteButtons
                      primaryFunction={() =>
                        navigate(`/course/tdg-certificate/${id}`)
                      }
                      primarySpan="Create Certificate"
                      secondaryFunction={() => navigate('/user')}
                      secondarySpan="Go Home"
                    />
                  )}
                  {/* Check for the part 2  */}
                  <Part2Checker course={userInfo?.courses?.[0]} />
                  {/* Certificate Generation Status */}
                  {!course?.courseName?.includes('TDG') && (
                    <CompleteButton course={course} userInfo={userInfo} />
                  )}
                  {userInfo?.courses?.[0] && (
                    <ReviewQuiz
                      userAnswers={userInfo?.courses?.[0]?.userAnswers}
                      course={course}
                    />
                  )}
                </QuizCompleteContainer>
              </>
            )}
          </UserDataProvider>
        )}
      </CourseDataProvider>
    </AuthCheckUser>
  );
};

export default CourseComplete;
